import React from "react";

const TrainingAndCertificationView = () => {
  return <>Training And CertificationView</>;
};

export default TrainingAndCertificationView;